import { withRBAC } from "../rbac";
import { attendance } from "./attendance";
import { departments } from "./departments";
import { designations } from "./designations";
import { EmployeeCreate } from "./employees/EmployeeCreate";
import { EmployeeEdit } from "./employees/EmployeeEdit";
import { EmployeeList } from "./employees/EmployeeList";
import { EmployeeShow } from "./employees/EmployeeShow";
import { holidays } from "./holidays";
import { leaveRequests } from "./leave-requests";
import { leaveTypes } from "./leave-types";
import {
  payrollComponents,
  payrollRuns,
  payrollSlips,
  salaryStructures,
} from "./payroll";

export const hr = {
  employees: {
    list: withRBAC(EmployeeList, "view_hr"),
    create: withRBAC(EmployeeCreate, "manage_hr"),
    edit: withRBAC(EmployeeEdit, "manage_hr"),
    show: withRBAC(EmployeeShow, "view_hr"),
    recordRepresentation: "name",
  },
  departments,
  designations,
  holidays,
  leaveTypes,
  leaveRequests,
  attendance,
  payrollComponents,
  salaryStructures,
  payrollRuns,
  payrollSlips,
};
